'use client'
import { LicenseInfo } from '@mui/x-license'

export default function MuiXLicense({ muiKey }: { muiKey: string }) {
	LicenseInfo.setLicenseKey(muiKey)
	return null
}
